var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "divRef", staticClass: "tempDesignBanner" }, [
    _c("span", [
      _vm._v(
        "We're rolling out a fresh new look and feel! You may notice some changes as we update our site."
      )
    ]),
    _vm._v(" "),
    _c("img", {
      attrs: { src: _vm.closeIcon, width: "24px", height: "24px" },
      on: {
        click: function($event) {
          return _vm.$emit("tdbCloseFunc")
        }
      }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-251b0ca4", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-251b0ca4","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TempDesignBanner.vue
// module id = 1453
// module chunks = 0